import { InjectionToken } from '@angular/core';
import { IAppConfig } from './app-config.interface';
import { NFIdentity } from './enums';

export const APP_DI_CONFIG: IAppConfig = {
  APP_TAG_TYPE_IDs: [2005],
  DEFAULT_PROFILE_MENU_CLASS_IDs: [127, 187, 130, NFIdentity.StandardHierarchy]
};

export const APP_CONFIG = new InjectionToken<IAppConfig>('app.config');
